<template>
<div class="w-full">
  <!-- <div class="flex flex-wrap" style="margin:10px;" v-if="activeQuestion.id == -1">
    <div class="justify-center">
      <h2  class="text-center"> 현재 과목에는 생성된 문제가 없습니다.  위 버튼을 눌러 문제를 생성해 보세요</h2>
    </div>
  </div> -->
  <div class="flex flex-wrap w-full" style="margin:10px;">
    <div class="vx-col  w-full" style="margin:10px;">
      <div class="vx-row justify-center" v-if="activeQuestion.id != -1">
        <chevron-left-icon @click="previous()" size="2.0x" class="custom-class cursor-pointer" style="color:#1d9cd3;"></chevron-left-icon>
        <span class="text-center " style="vertical-align:middle; color:#1d9cd3; font-size:20px;"><strong> 문제- ID:{{data_local.id}} </strong></span>
        <chevron-right-icon @click="next()" size="2.0x" class="custom-class cursor-pointer" style="color:#1d9cd3;"></chevron-right-icon>
      </div>

      <div class="vx-row justify-center" v-if="activeQuestion.id == -1">
        <span class="text-center " style="vertical-align:middle; color:#1d9cd3; font-size:20px;"><strong> 문제가 없습니다. 상단 버튼을 눌러 생성 해보세요 </strong></span>
      </div>
    </div>
    <div v-if="activeQuestion.id != -1" class="w-full">
      <transition name="zoom-out">
        <div class=" w-full" v-if="activePage" v-show="activePage">
          <div class="vx-col  w-full" style="margin:10px;">
            <vx-card>
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button color="primary" style="olor:#1d9cd3; margin-right:3px; justify-end;" type="border" icon-pack="feather" size="small" icon="icon-save" @click="saveQuestion()">저장</vs-button>
                  <vs-button class="flex items-center" color="danger" type="flat" icon="icon-trash" icon-pack="feather" @click="deleteQuestion()">삭제</vs-button>
                </div>
              </div>
              <div class="vx-row">
                <!-- Address Col -->
                <div class="vx-col w-full md:w-1/2">
                  <vs-input class="w-full mt-4" label="문제 점수" v-model="data_local.score" name="점수" />

                </div>
                <div class="vx-col w-full md:w-1/2">
                  <!-- Col Content -->
                  <div class="mt-4">
                    <label class="text-sm">문제 타입</label>
                    <div class="mt-2">
                      <vs-radio v-model="questionType" :vs-value="typeVal[0]" class="mr-4">객관식</vs-radio>
                      <vs-radio v-model="questionType" :vs-value="typeVal[1]" class="mr-4">주관식</vs-radio>
                      <vs-radio v-model="questionType" :vs-value="typeVal[2]" class="mr-4">복수 선택 객관식</vs-radio>
                      <vs-radio v-model="questionType" :vs-value="typeVal[3]" class="mr-4">듣기 평가</vs-radio>
                    </div>
                  </div>
                  <div class="mt-4">
                    <label class="text-sm">연속 문제 / 순서 보장</label>
                    <vs-switch color="success" v-model="sequence">
                      <span slot="on">on</span>
                      <span slot="off">off</span>
                    </vs-switch>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col  w-full " style="margin:10px;">
            <vx-card>
              <vs-button class="w-full" v-if="questionActive" @click="questionActive = false" style="margin-bottom:10px;">숨기기</vs-button>
              <vs-button class="w-full" v-if="questionActive == false" @click="questionActive = true" style="margin-bottom:10px;">문제 보이기</vs-button>
              <!-- <transition name="slide"> -->
              <div v-if="questionActive">
                <div style="margin:10px;">
                  <span><strong> 문제 </strong></span>
                  <quill-editor v-model="data_local.title" :options="editorOption"></quill-editor>
                </div>
                <div style="margin:10px;">
                  <span><strong> 문제 추가 정보 </strong></span>
                  <!-- <quill-editor v-model="data_local.question_info"></quill-editor> -->
                  <div class="quill-wrap">
                    <quill-editor v-model="data_local.question_info" :options="editorOption">
                    </quill-editor>
                  </div>
                </div>
              </div>
              <!-- </transition> -->
            </vx-card>
          </div>
          <div class="vx-col  w-full " style="margin:10px;">
            <vx-card>
              <div v-if="data_local.question_type == 4">
                <div style="margin:10px;">
                  <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;" v-if="data_local.audio_file_name">
                    <div class="w-full" style="margin-top:35px; margin-bottom:-3px;">
                      <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                        <div class="vx-card collapsible-content" style="text-align:center;">
                          <div class="vx-row" style="margin:5px; ">
                            <div style="width: 90%;">
                              <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                                {{data_local.audio_file_name}}
                              </div>
                            </div>
                            <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                              <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deleteAudioFile()" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filebox" style="margin-top:30px;">
                    <label for="inputFile">오디오 파일 첨부</label>
                    <input type="file" @change="updateAudioFile" id="inputFile" name="inputFile" multiple>
                  </div>
                </div>
              </div>
              <!-- </transition> -->
            </vx-card>
          </div>
          <div class="vx-col  w-full " style="margin:10px;">
            <vx-card>
              <vs-button class="w-full" v-if="solvingActive" @click="solvingActive = false" style="margin-bottom:10px;">숨기기</vs-button>
              <vs-button class="w-full" v-if="solvingActive == false" @click="solvingActive = true" style="margin-bottom:10px;">문제 풀이 보이기</vs-button>
              <div v-if="solvingActive">
                <vx-card>
                  <input-tag v-model="tags" placeholder="문제에 연관되는 단어를 태그해보세요." style="border:none;" />
                </vx-card>
                <div style="margin:10px; ">
                  <span><strong> 문제 풀이 </strong></span>
                  <quill-editor v-model="data_local.solving" :options="editorOption"></quill-editor>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col  w-full" style="margin:10px;">
            <multiple-question v-if="data_local.question_type == 3" />
            <answer v-if="data_local.question_type == 2" />
            <number-question v-if="data_local.question_type == 1 || data_local.question_type == 4" />
          </div>
        </div>
      </transition>
    </div>
  </div>

  <vs-prompt class="email-compose" title="APP 보기" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="updateQuestion" :active.sync="activePrompt">
    <vs-tabs alignment="fixed">
      <vs-tab label="문제">
        <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
          <form @submit.prevent>
            <vx-card class="box1 p-4" style="width:480px;" v-if="data_local.question_type == 4" :is="scrollbarTag">
              <audio controls controlsList="nodownload">
                <source :src="audioUrl" type="audio/mp3" />
              </audio>
            </vx-card>
            <vx-card class="box1 p-4 scroll-area" style="width:480px; height:150px;" :is="scrollbarTag">
              <div class="output ql-snow">
                <div class="ql-editor h-full" v-html="data_local.title"></div>
              </div>
            </vx-card>
            <vx-card class="box1 p-4 scroll-area" style="width:480px; height:350px; shadow:5px;" :is="scrollbarTag" v-if="data_local.question_info">
              <div class="text-right">
                <vs-button @click="popupActive=true" class="round" color="#ccc" style="padding-left:15px; padding-right:15px; padding-top:3px; padding-bottom:3px;">전체보기</vs-button>
                <!-- <div style="height:300px; width:300px" v-html="data_local.question_info"></div> -->
                <!-- <quill-editor disable v-model="data_local.question_info"></quill-editor>s -->
                <div class="output ql-snow" :is="scrollbarTag">
                  <div class="ql-editor h-full" v-html="data_local.question_info"></div>
                </div>
              </div>
            </vx-card>
            <vx-card class="box1 p-4 scroll-area" style="width:480px;  height:180px;" :is="scrollbarTag" v-if="data_local.question_info">
              <MultipleView :activeQuestion="data_local" />
            </vx-card>
            <vx-card class="box1 p-4 scroll-area" style="width:480px;  height:480px;" :is="scrollbarTag" v-if="!data_local.question_info">
              <MultipleView :activeQuestion="data_local" />
            </vx-card>
          </form>
        </component>
      </vs-tab>
    </vs-tabs>
  </vs-prompt>

  <vs-popup class="holamundo" title="전체 보기" :active.sync="popupActive">
    <div class="output ql-snow">
      <div class="ql-editor h-full" v-html="data_local.question_info"></div>
    </div>
    <!-- {{data_local.question_info}} -->
  </vs-popup>
  <vs-prompt title="파일 업로드" :buttons-hidden="true" :active.sync="uploadPrompt">
    <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
      <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 업로드 중입니다 - 조금만 기다려주세요 :)</label>
      <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </component>
  </vs-prompt>
</div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import MultipleQuestion from './MultipleQuestion.vue'
import Answer from './Answer.vue'
import NumberQuestion from './NumberQuestion.vue'
import InputTag from 'vue-input-tag'
import MultipleView from './MultipleView.vue'

// import {
//   quillEditor
// } from 'vue-quill-editor'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import radioAnswer from './RadioAnswer.vue'
import {
  ChevronLeftIcon
} from 'vue-feather-icons'
import {
  ChevronRightIcon
} from 'vue-feather-icons'

import {
  quillEditor
} from 'vue-quill-editor'

import Quill from 'quill'
import {
  ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

export default {
  data() {
    return {
      content: '',
      sequence: false,
      audioUrl: '',
      uploadPrompt: false,
      questionType: 0,
      editorOption: {
        modules: {
          imageDrop: true,
          imageResize: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{
              'header': 1
            }, {
              'header': 2
            }],
            [{
              'list': 'ordered'
            }, {
              'list': 'bullet'
            }],
            [{
              'script': 'sub'
            }, {
              'script': 'super'
            }],
            [{
              'indent': '-1'
            }, {
              'indent': '+1'
            }],
            [{
              'direction': 'rtl'
            }],
            [{
              'size': ['small', false, 'large', 'huge']
            }],
            [{
              'header': [1, 2, 3, 4, 5, 6, false]
            }],
            [{
              'font': []
            }],
            [{
              'color': []
            }, {
              'background': []
            }],
            [{
              'align': []
            }],
            ['clean'],
            ['link', 'image', 'video']
          ],
        },
        theme: 'snow'
      },
      typeVal: [1, 2, 3, 4],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      audioActive: false,
      solvingActive: false,
      questionActive: true,
      radios1: 0,
      popupActive: false,
      data_local: '',
      question_title: '',
      question_info: '',
      multiple_text: '',
      activePrompt: false,
      intervalObj: null,
      activePage: true,
      tags: [],
      audioFile: '',
      //   radioAnswerList:[{'answer':'용어의 개념을 설명하며 청중의 이해를 돕고 있다.'},{'answer':'청중의 경험을 환기시켜 발표 내용에 대해 친근감을 느끼게하고 있다.'},
      // {'answer':'발표 내용과 관련된 질문을 하여 청중과의 상호 작용을 유도하고 있다.'},{'answer':'청중이 발표 내용을 예측할 수 있도록 발표 순서를 제시하며 발표를 시작하고 있다.'},
      // {'answer':'담화 표지를 사용하여 청중이 발표 내용을 구조적으로 파악할 수 있도록 하고 있다.'}],
    }
  },
  methods: {
    updateAudioFile() {
      this.uploadPrompt = true
      this.audioFile = document.getElementById("inputFile").files[0]
      this.data_local.audio_file_name = this.audioFile.name
      this.$store.dispatch('etest/updateAudioFile', {
        param: {
          id: this.data_local.id
        },
        file: this.audioFile
      }).then(() => {
        this.uploadPrompt = false
        this.$vs.notify({
          color: 'success',
          title: '파일 저장 완료',
        })
      }).catch(() => {
        this.uploadPrompt = false
        this.data_local.audio_file_name = ''
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    deleteAudioFile() {
      this.$store.dispatch('etest/deleteAudioFile', this.data_local.id)
        .then(() => {
          // document.getElementById("inputFile").files[0] = null
          this.$vs.notify({
            color: 'success',
            title: '삭제 완료',
          })
          this.data_local.audio_file_name = ''
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    updateQuestion() {
      console.log( this.data_local)
      if (this.sequence == true) {
        this.data_local.sequence = this.getIndex
      }

      this.$store.dispatch('etest/updateEtestQuestion', this.data_local)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '저장 완료',
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    saveQuestion() {
      this.data_local.answer = this.activeQuestion.answer
      this.data_local.answer_multiple = this.activeQuestion.answer_multiple
      this.data_local.answer_number = this.activeQuestion.answer_number

      if (this.data_local.question_type == 4) {
        var token = ''
        if (localStorage.getItem("filleduToken")) {
          token = localStorage.getItem("filleduToken")
        } else if (sessionStorage.getItem("filleduToken")) {
          token = sessionStorage.getItem("filleduToken")
        }

        this.audioUrl = this.$store.state.baseURL + "/streaming/audio/question/id=" + this.data_local.id + "&token=" + token
      }
      this.activePrompt = true
    },
    previous() {
      // const index = this.questionList.findIndex((item) => item.id == this.activeQuestion.id) - 1
      // if (index != -1) {
      //   this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[index])
      // } else {
      //   this.$vs.notify({
      //     color: 'danger',
      //     title: '첫번째 문제 입니다.',
      //   })
      // }
    },
    next() {
      // const index = this.questionList.findIndex((item) => item.id == this.activeQuestion.id) + 1
      // if (index < this.questionList.length) {
      //   this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[index])
      // } else {
      //   this.$vs.notify({
      //     color: 'danger',
      //     title: '마지막 문제 입니다.',
      //   })
      // }
    },
    deleteQuestion() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.getIndex + '번째 문제 삭제',
        text: '정말 삭제하시겠습니까? 작성된 정보가 모두 삭제 됩니다. ',
        accept: this.accept
      })
    },
    accept() {
      this.$store.dispatch('etest/deleteQuestion', this.data_local.id)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '삭제 완료',
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    clearFields() {
      this.$nextTick(() => {})
    },
    init() {
      this.data_local = ''
      this.data_local = JSON.parse(JSON.stringify(this.activeQuestion))
      this.activePage = false
      this.questionType = this.data_local.question_type

      if (this.data_local.sequence == null || this.data_local.sequence == 0) {
        this.sequence = false
      } else {
        this.sequence = true
      }

      this.intervalObj = setInterval(() => {
        this.activePage = true
        clearInterval(this.intervalObj)
      }, 5)
    }
  },
  watch: {
    questionType() {
      if (this.questionType == 4) {
        this.sequence = true
      }
      this.data_local.question_type = this.questionType
    },
    activeQuestionId() {
      if (this.activeQuestionId == -1) {
        return
      }
      this.init()
    }
  },
  computed: {
    // getIndex() {
    //   return this.questionList.findIndex((item) => item.id == this.activeQuestion.id) + 1
    // },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    activeQuestion() {
      return this.$store.state.etest.activeQuestion
    },
    activeQuestionId() {
      return this.$store.state.etest.activeQuestion.id
    },
    // questionList() {
    //   return this.$store.state.etest.questionList
    // },
  },
  components: {
    VuePerfectScrollbar,
    // radioAnswer,
    ChevronLeftIcon,
    ChevronRightIcon,
    quillEditor,
    MultipleQuestion,
    Answer,
    NumberQuestion,
    'input-tag': InputTag,
    'MultipleView': MultipleView
  },
  created() {
    console.log('created test')
    // this.$store.dispatch('etest/deleteQuestion',)
    this.init()
    // console.log(this.data_local)
  }
}
</script>


<style lang="scss">
.box1 {
    border: 1px solid;
    padding: 10px;
    border-color: #ccc;
    width: 100%;
}

.zoom-out-enter-active,
.zoom-out-leave-active {
    transition: opacity 0.35s ease-in-out, transform 0.45s ease-out;
}
.zoom-out-enter,
.zoom-out-leave-to {
    opacity: 0;
    transform: scale(0);
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: opacity 0.35s, transform 0.4s;
}
.slide-fade-enter {
    opacity: 0;
    transform: translateY(-30%);
}

.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(30%);
}

#email-app {
    .vs-sidebar--background {
        position: absolute;
    }
    .select-all-chexkbox {
        .vs-checkbox {
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
            overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
            overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 6.3%);

        &:not(.ps) {
            overflow-y: auto;
        }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }

    .email__mails {

        .email__mail-item {
            transition: all 0.35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;

                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 3px 10px 0 #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar {
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header {
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all 0.35s;
        }

        .mail__attachment {
            .vs-chip--text {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }
}
// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 500px;
        max-height: 800px;
        .vs-dialog-text {
            padding: 0;
            .scroll-area {
                max-height: 800px;
                &:not(.ps) {
                    overflow-y: auto;
                }
            }
            .compose-mail-attachment {
                .con-input-upload {
                    margin: 0;
                }
            }
        }
    }
    .con-img-upload {
        .con-input-upload {
            height: 2.5rem;
            width: 100%;
        }
        .img-upload {
            // height: 4rem;
            margin: 0 1.5rem 0.5rem 0;
        }
    }
    .quill-editor {
        margin-bottom: 1.5rem;
    }
    .ql-editor {
        height: 250px;
    }
}
</style>
